import { render, staticRenderFns } from "./domainSettingItem1.vue?vue&type=template&id=179d8f0a&scoped=true&"
import script from "./domainSettingItem1.vue?vue&type=script&lang=js&"
export * from "./domainSettingItem1.vue?vue&type=script&lang=js&"
import style0 from "./domainSettingItem1.vue?vue&type=style&index=0&id=179d8f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d8f0a",
  null
  
)

export default component.exports